import { render } from "./GalleryExhibition.vue?vue&type=template&id=9c3a67e8"
import script from "./GalleryExhibition.vue?vue&type=script&lang=js"
export * from "./GalleryExhibition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__